import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service';
import { ConfigService } from 'src/app/services/config-service.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from 'src/environments/environment';
import { ServiceProvider } from 'src/app/models/enums/service-provider.enum';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss'],
})
export class DocumentationComponent {
  successRes = `
  { 
    "statusCode": 200, 
    "message": "Successful", 
    "data": [ 
        { 
            "serviceId": "0000000000", 
            "title": "Title 01", 
            "validity": "Monthly", 
            "price": 0.0,
            "isRenewal" : true
        }, 
        { 
            "serviceId": "0000000000", 
            "title": "Title 02", 
            "validity": "Daily", 
            "price": 0.0 ,
            "isRenewal" : true
        }, 
        { 
            "serviceId": "0000000000", 
            "title": "Title 03", 
            "validity": "Weekly", 
            "price": 0.0 ,
            "isRenewal" : true
        } 
    ] 
} `;
  wrongServiceRes = `
    { 
        "statusCode": 500, 
        "message": "Something went wrong! Please try again.", 
        "data": null 
    }`;

  reqBody = `
    { 
        "MSISDN": "880100000000", 
        "ServiceId": "2251" 
    } 
 `;
  reqSucRes = `
    { 
        "statusCode": 200, 
        "message": "Successfull" 
    }
 `;
  otpVerifyReqBody = `
 { 
    "MSISDN": "880100000000", 
    "ServiceId": "000000000", 
    "ConsentNo": "00000" 
} `;

  optVerifySucRes = `
{ 
    "statusCode": 200, 
    "message": "Successfull" 
} `;
  optInsufficentBalRes = `
{ 
    "statusCode": 200, 
    "message": "Dear user, your transaction cannot be completed due to insufficient balance." 
} `;
  optDuplicateRes = `
{
    "statusCode": 200,
    "message": "Dear user, You have requested for one OTP. For another OTP please wait for 5 minutes."
}`;
blacklistRes = `
{
    "statusCode": 200,
    "message": "Dear user, You are blacklist from this service. Please SMS: START to 6888 and try again."
}`;

  optVerifyServerError = `
{ 
    "statusCode": 500, 
    "message": "Something went wrong! Please try again.", 
    "data": null 
}  `;

  reqServerErrorRes = `
    { 
        "statusCode": 500, 
        "message": "Something went wrong! Please try again.", 
        "data": null 
    }  
 `;
  checkReqRes = `
 {
     "statusCode": 200,
     "message": "Successful",
     "data": {
         "msisdn": "880100000000",
         "serviceId": "00000000",
         "nextRenewalDate": 0
     }
 } 
 `;
  checkNotFoundRes = `
    {
        "statusCode": 200,
        "message": "Not found any subscription",
        "data": null
    }
 `;
  subscriptionCheckApiNotFoundRes = `
 {
     "statusCode": 200,
     "message": "Not found any subscription",
     "data": null
 }
`;
  cancelReq = `
 {
     "statusCode": 200,
     "message": "Successful"
 }
 `;
  cancelRes = `
 {
     "statusCode": 200,
     "message": "Failed"
 }'`;
  ipBlockRes = `
{
    "message": "You are permanently blocked!",
    "details": "Because of excesive request you are blocked. Contact with administrator."
}'`;

  vendor: string | null = null;
  apiRouteSegment: string = '';
  domain = environment.apiUrl;
  checkSubscriptionApi: string = '';
  cancelSubscriptionApi: string = '';
  productsApi: string = '';
  createCheckoutSessionApi: string = '';
  verifyCheckoutSessionApi: string = '';
  isValidProvider: boolean = false;

  constructor(
    private config: ConfigService,
    private route: ActivatedRoute,
    public authService: AuthService,

    private message: NzMessageService
  ) {
    this.route.queryParams.subscribe((params) => {
      const serviceProvider: string = params['serviceProvider'];
      if (
        serviceProvider &&
        serviceProvider == ServiceProvider.Cloud7Ltd.toString()
      ) {
        this.apiRouteSegment = 'banglalinkcloud7';
        this.isValidProvider = true;
      } else if (
        serviceProvider == ServiceProvider.GakkMedia.toString() ||
        serviceProvider == ServiceProvider.ShadhinMusicLtd.toString()
      ) {
        this.apiRouteSegment = 'banglalink';
        this.isValidProvider = true;
      } else if (serviceProvider == ServiceProvider.Maverick.toString()) {
        this.apiRouteSegment = 'banglalink';
        this.domain = environment.blMaverickApiUrl;
        this.isValidProvider = true;
      } else {
        this.isValidProvider = false;
      }
    });

    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.config.getBlDetailsByMarchent(params['id']).subscribe((e) => {
          console.log(e);
          if (e && e.length > 0) {
            this.vendor = e[0].merchant;

            this.initializeApiRoutes();
          }
        });
      }
    });
  }

  getMessage() {
    if (this.isValidProvider) {
      return 'Not found any docs for you please contact with administrator.';
    } else {
      return `No service provider found please contact with administrator.`;
    }
  }

  initializeApiRoutes() {
    this.checkSubscriptionApi = `${this.domain}/${this.apiRouteSegment}/billing/check-subscription/${this.vendor}/8800000000000`;
    this.cancelSubscriptionApi = `${this.domain}/${this.apiRouteSegment}/billing/cancel-subscription`;
    this.productsApi = `${this.domain}/${this.apiRouteSegment}/billing/products/${this.vendor}`;
    this.createCheckoutSessionApi = `${this.domain}/${this.apiRouteSegment}/checkout/create-checkout-session`;
    this.verifyCheckoutSessionApi = `${this.domain}/${this.apiRouteSegment}/checkout/verify-checkout-session`;
  }
}
